// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b1f2ab71","304":"d9a2acb8","376":"5870b34a","453":"f748d204"}[chunkId] + ".chunk.js";
};